

























































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import { ExtendedVessel } from "@/types/vessel";
import { MachineModel, VesselMachineModelsModel } from "@/types/machineModel";
import VesselsModule from "@/store/clients/Vessels.module";
import UserModule from "@/store/clients/User.module";
import MachineModelsModule from "@/store/clients/MachineModels.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const Vessels = getModule(VesselsModule, store);
const User = getModule(UserModule, store);
const MachineModels = getModule(MachineModelsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {},
})
export default class MachineLearningModels extends Vue {
  get vessels() {
    return Vessels.extendedVessels;
  }

  get companyId(): number | null {
    const companyId = User.userCompanyId;
    return companyId;
  }

  get vesselMachineModels(): VesselMachineModelsModel[] {
    const models = MachineModels.vesselMachineModels;
    return models;
  }

  get isLoading(): boolean {
    const loading = MachineModels.isLoading;
    return loading;
  }

  get uniqueModelNames(): string[] {
    const nameSet = new Set<string>();

    this.vesselMachineModels.forEach(vesselModel => {
      vesselModel.machineModels.forEach(model => {
        nameSet.add(model.name);
      });
    });

    return Array.from(nameSet).sort();
  }

  get tableData() {
    // If no vessel machine models, return empty array
    if (!this.vesselMachineModels || this.vesselMachineModels.length === 0) {
      return [];
    }

    // Create a map of vesselId -> Set of model names
    const vesselModelsMap = new Map<number, Set<string>>();

    this.vesselMachineModels.forEach(vesselModel => {
      const modelNames = new Set<string>();
      vesselModel.machineModels.forEach(model => {
        modelNames.add(model.name);
      });
      vesselModelsMap.set(vesselModel.vesselId, modelNames);
    });

    // Build table rows only for vessels that have models
    return this.vessels
      .filter(vessel => vesselModelsMap.has(vessel.id))
      .map(vessel => {
        const modelNames = vesselModelsMap.get(vessel.id)!;
        const modelsObj: Record<string, boolean> = {};

        this.uniqueModelNames.forEach(modelName => {
          modelsObj[modelName] = modelNames.has(modelName);
        });

        return {
          vesselId: vessel.id,
          vesselName: vessel.name,
          models: modelsObj,
        };
      });
  }

  async fetchMachineModels(): Promise<void> {
    if (!this.companyId) {
      Snackbar.showSnackbar({ text: "Company ID not found" });
      return;
    }

    try {
      await MachineModels.fetchCompanyMachineModels(this.companyId);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to load machine learning models" });
    }
  }

  async created(): Promise<void> {
    await this.fetchMachineModels();
  }

  mounted(): void {
    // Component mounted
  }
}
